import _ from 'lodash'

const classification = [
  { label: 'Not interested', value: 'not_interested' },
  { label: 'Applied', value: 'applied' },
  { label: 'Screening', value: 'screening' },
  { label: 'Interested', value: 'interested' },
  { label: 'In Contact', value: 'in_contact' },
  { label: 'Investment', value: 'investment' },
]

export function getStartupClassification() {
  return classification
}
export default classification

export const stateByValue = _.keyBy(classification, 'value')
